<template>
  <v-container id="reference-term-list">
    <v-row>
      <v-col cols="8" md="8" class="breadcrumbs">
        <v-breadcrumbs :items="breadcrumbs" :large="true" :divider="'>'">
        </v-breadcrumbs>
      </v-col>

      <v-col cols="4" sm="4">
        <div class="text-right">
          <div cols="10" md="1">
            <app-modal-upload :dialog="false"> </app-modal-upload>
          </div>
        </div>
      </v-col>
    </v-row>

    <v-row>
      <v-col class="separator-list">
        <v-divider></v-divider>
      </v-col>
    </v-row>

    <v-row>
      <v-col>
        <app-group-solution-combobox
          :filter="filter"
          :groupSolution="groupSolution"
          @changeGroupSolution="
            (grupoSolucaoId) => {
              this.filter.tarefaId = 0;
              this.filter.solucaoId = 0;
              this.filter.grupoSolucaoId = grupoSolucaoId;
              reloadValues();
            }
          "
        ></app-group-solution-combobox>
      </v-col>
      <v-col>
        <app-solution-combobox
          :filter="filter"
          :filterSolutions="
            this.filter.grupoSolucaoId
              ? this.solutions.filter((i) => {
                  return i.grupoSolucaoId === this.filter.grupoSolucaoId;
                })
              : this.solutions
          "
          @changeSolution="
            (solucaoId) => {
              this.filter.solucaoId = solucaoId;
              this.filter.tarefaId = 0;

              reloadValues();
            }
          "
        ></app-solution-combobox>
      </v-col>
      <v-col>
        <app-task-combobox
          :filter="filter"
          :filterTasks="
            this.filter.solucaoId
              ? this.tasks.filter((i) => {
                  return i.solucaoId === this.filter.solucaoId;
                })
              : this.filter.grupoSolucaoId
              ? this.tasks.filter((i) => {
                  this.filter.solutions.some(
                    (val) => i.solucaoId === val.solucaoId
                  );
                })
              : this.tasks
          "
          @changeTask="
            (tarefaId) => {
              this.filter.tarefaId = tarefaId;
              reloadValues();
            }
          "
        ></app-task-combobox>
      </v-col>
    </v-row>

    <v-row>
      <v-tabs vertical>
        <v-tab>
          <v-icon left>mdi-domain</v-icon>
          Projetos
        </v-tab>
        <v-tab>
          <v-icon left>mdi-axis-arrow</v-icon>
          {{ isAT ? "Grupos de Iniciativa" : "Grupos de Solução" }}
        </v-tab>
        <v-tab>
          <v-icon left>mdi-beaker-outline</v-icon>
          {{ isAT ? "Iniciativas" : "Soluções" }}
        </v-tab>
        <v-tab>
          <v-icon left>mdi-calendar-check-outline</v-icon>
          {{ isAT ? "Atividades" : "Tarefas" }}
        </v-tab>
        <v-tab>
          <v-icon left>mdi-book-search-outline</v-icon>
          Evidências
        </v-tab>

        <v-tab-item>
          <v-col>
            <app-project-list></app-project-list>
          </v-col>
        </v-tab-item>
        <v-tab-item>
          <v-col>
            <app-group-solution-list
              :filter="filter"
              @reload="loadGroupSolution"
            ></app-group-solution-list>
          </v-col>
        </v-tab-item>
        <v-tab-item>
          <app-solution-list
            ref="solutionList"
            :filter="filter"
            :solutions="filter.solutions"
            :groupSolutionId="filter.grupoSolucaoId"
            @reload="loadSolutions()"
          ></app-solution-list>
        </v-tab-item>
        <v-tab-item>
          <app-task-list
            :filter="filter"
            :tasks="filter.tasks"
            :solutionId="filter.solucaoId"
            @reload="
              loadTasks();
              loadEvidences();
            "
          ></app-task-list>
        </v-tab-item>
        <v-tab-item>
          <app-evidence-list
            :filter="filter"
            :evidences="filter.evidences"
            :tasksId="filter.tarefaId"
            :municipioTarefa="filter.municipioTarefa"
            @reload="loadEvidences()"
          ></app-evidence-list>
        </v-tab-item>
      </v-tabs>
    </v-row>
  </v-container>
</template>

<script>
import AppProjectList from "@/modules/project/components/List";
import AppGroupSolutionList from "@/modules/group-solution/components/List";
import AppSolutionList from "@/modules/solution/components/List";
import AppTaskList from "@/modules/task/components/List";
import AppEvidenceList from "@/modules/evidence/components/List";
import { AppGroupSolutionCombobox } from "@/modules/group-solution";
import { AppSolutionCombobox, solutionAPI } from "@/modules/solution";
import { AppTaskCombobox, taskAPI } from "@/modules/task";
import { evidenceAPI } from "@/modules/evidence";
import { mapActions, mapGetters } from "vuex";
import { AppModalUpload } from "@/modules/reference-term";
import { groupSolutionAPI } from "@/modules/group-solution/API/GroupSolutionAPI";

export default {
  components: {
    AppProjectList,
    AppGroupSolutionList,
    AppSolutionList,
    AppTaskList,
    AppEvidenceList,
    AppGroupSolutionCombobox,
    AppSolutionCombobox,
    AppTaskCombobox,
    AppModalUpload,
  },

  data() {
    return {
      headers: [
        {
          text: "#",
          sortable: false,
        },
        {
          text: "Nome",
          align: "left",
          sortable: false,
          value: "name",
        },
        { text: "Plano", value: "calories" },
        { text: "Carga Horária", value: "fat" },
      ],
      payload: {},
      breadcrumbs: [
        {
          text: "Gestão de Termos de Referência",
          disabled: true,
          href: "termo-referencia",
        },
      ],
      filter: {
        grupoSolucaoId: 0,
        solucaoId: 0,
        tarefaId: 0,
        evidenciaId: 0,
        solutions: [],
        tasks: [],
        evidences: [],
      },
      solutions: [],
      tasks: [],
      evidences: [],
      groupSolution: [],
    };
  },
  methods: {
    ...mapActions(["setLoading"]),
    reloadValues() {
      if (
        this.filter.grupoSolucaoId &&
        this.filter.solucaoId &&
        this.filter.tarefaId
      ) {
        this.filter.solutions = this.solutions.filter(
          (i) => i.solucaoId === this.filter.solucaoId
        );

        this.filter.tasks = this.tasks.filter(
          (i) => i.tarefaId === this.filter.tarefaId
        );

        this.filter.evidences = this.evidences.filter((i) =>
          this.filter.tasks.some((value) => i.tarefaId === value.tarefaId)
        );
      } else if (this.filter.grupoSolucaoId && this.filter.solucaoId) {
        this.filter.solutions = this.solutions.filter((i) => {
          return (
            i.grupoSolucaoId === this.filter.grupoSolucaoId &&
            i.solucaoId === this.filter.solucaoId
          );
        });

        this.filter.tasks = this.tasks.filter((i) =>
          this.filter.solutions.some((value) => i.solucaoId === value.solucaoId)
        );

        this.filter.evidences = this.evidences.filter((i) =>
          this.filter.tasks.some((value) => i.tarefaId === value.tarefaId)
        );
      } else if (this.filter.tarefaId && this.filter.solucaoId) {
        this.filter.solutions = this.solutions.filter((i) => {
          return i.solucaoId === this.filter.solucaoId;
        });

        this.filter.tasks = this.tasks.filter(
          (i) => i.tarefaId === this.filter.tarefaId
        );

        this.filter.evidences = this.evidences.filter((i) =>
          this.filter.tasks.some((value) => i.tarefaId === value.tarefaId)
        );
      } else if (this.filter.grupoSolucaoId) {
        this.filter.solutions = this.solutions.filter((i) => {
          return i.grupoSolucaoId === this.filter.grupoSolucaoId;
        });

        this.filter.tasks = this.tasks.filter((i) =>
          this.filter.solutions.some((value) => i.solucaoId === value.solucaoId)
        );

        this.filter.evidences = this.evidences.filter((i) =>
          this.filter.tasks.some((value) => i.tarefaId === value.tarefaId)
        );
      } else if (this.filter.solucaoId) {
        this.filter.evidenciaId = 0;
        this.filter.tarefaId = 0;
        this.filter.solutions = this.solutions.filter((i) => {
          return i.solucaoId === this.filter.solucaoId;
        });
        this.filter.tasks = this.tasks.filter(
          (i) => i.solucaoId === this.filter.solucaoId
        );

        this.filter.evidences = this.evidences.filter((i) =>
          this.filter.tasks.some((value) => i.tarefaId === value.tarefaId)
        );
      } else if (this.filter.tarefaId) {
        this.filter.evidenciaId = 0;
        this.filter.tasks = this.tasks.filter(
          (i) => i.tarefaId === this.filter.tarefaId
        );

        this.filter.evidences = this.evidences.filter((i) =>
          this.filter.tasks.some((value) => i.tarefaId === value.tarefaId)
        );
      } else {
        this.filter.evidences = this.evidences;
        this.filter.tasks = this.tasks;
        this.filter.solutions = this.solutions;
      }

      this.setLoading(false);
    },
    loadEvidences() {
      this.setLoading(true);
      evidenceAPI
        .list()
        .then((resp) => {
          this.evidences = resp.data;
          this.filter.evidences = resp.data;
          this.reloadValues();
          this.setLoading(false);
        })
        .catch((resp) => {
          this.setLoading(false);
          this.$notification.error("Erro ao listar evidências");
        });
    },
    loadTasks() {
      this.setLoading(true);
      taskAPI
        .list()
        .then((resp) => {
          this.tasks = resp.data;
          this.filter.tasks = resp.data;
          this.reloadValues();
          this.setLoading(false);
        })
        .catch((resp) => {
          this.setLoading(false);
          this.$notification.error(
            `Erro ao listar ${this.isAT ? "atividades" : "tarefas"}`
          );
        });
    },
    loadSolutions() {
      this.setLoading(true);
      solutionAPI
        .list()
        .then((resp) => {
          this.solutions = resp.data;
          this.filter.solutions = resp.data;
          this.reloadValues();
        })
        .catch((resp) => {
          this.setLoading(false);
          this.$notification.error(
            `Erro ao ${this.isAT ? "iniciativas" : "soluções"}`
          );
        });
    },
    loadGroupSolution() {
      this.setLoading(true);
      groupSolutionAPI
        .list()
        .then((resp) => {
          this.groupSolution = resp.data;
          this.reloadValues();
        })
        .catch((resp) => {
          this.setLoading(false);
          this.$notification.error(
            `Erro ao listar ${
              this.isAT ? "grupos de iniciativas" : "grupos de soluções"
            }`
          );
        });
    },
  },
  mounted() {
    this.loadGroupSolution();
    this.loadSolutions();
    this.loadTasks();
    this.loadEvidences();
  },
  computed: {
    ...mapGetters([
      "loading",
      "isAdmin",
      "isConsultorCondutorMunicipio",
      "isConsultorEspecialistaMunicipio",
      "isADMunicipio",
      "isAuthenticated",
      "isAT",
    ]),
  },
};
</script>

<style lang="scss">
@import "./style.scss";
</style>
